import { create } from 'zustand';

import { GetParametrosParams, getParametros } from '@/shared/actions/erp/administration/system-parameters/system-parameters.actions';
import { MantetenimientoSystem, ValorMinEquifaxSystem } from '@/shared/interfaces/erp/administration/system-parameters/parametro.interface';
import { Parametro } from '@/shared/interfaces/erp/administration/system-parameters/parametro.interface';
import { useDiccionarioMotivo } from '../diccionario_motivo/diccionario_motivo.store';
import { SystemParametersEnum } from '@/shared/constants/administration/system-params/system-params.interface';


export interface SystemParamsStoreState {
  systemParams: Parametro[];
  isLoadingSystemParams: boolean;
  getSystemParams: (params?: GetParametrosParams) => Promise<void>;

  ///* sistema en mantenimiento
  mantenimiento: MantetenimientoSystem | null;

  ///* valor minimo de equifax
  valorMinEquifax: ValorMinEquifaxSystem | null;

  ///* usuarios con permiso ayuda social
  userPermisoAyudaSocial: string[] | null;

  ///* socket
  emitParametroSistema: (params: Parametro) => void
  onInformacionSistema: () => void

}

export const useSystemParamsStore = create<SystemParamsStoreState>(set => ({
  userPermisoAyudaSocial: null,
  valorMinEquifax: null,
  equiposAdicionales: null,
  mantenimiento: null,
  systemParams: [],
  isLoadingSystemParams: false,
  getSystemParams: async (params) => {

    set({ isLoadingSystemParams: true });
    const { data } = await getParametros(params);    
    set({ systemParams: data?.data || [] });

    const dataParams = data.data;
    ///* mantenimiento del sistema
    const mantenimiento = dataParams.find(e => e.slug == SystemParametersEnum.MANTENIMIENTO);
    if (mantenimiento) {
      const valor = JSON.parse(mantenimiento.valor)
      set({ mantenimiento: valor })
    }
    const valorMinEquifax = dataParams.find(e => e.slug == SystemParametersEnum.VALOR_MINIMO_EQUIFAX)    
    if (valorMinEquifax) {
      const valor: ValorMinEquifaxSystem = JSON.parse(valorMinEquifax.valor)
      set({ valorMinEquifax: valor })
    }
    const userPermisoAyudaSocial = dataParams.find(e => e.slug == SystemParametersEnum.USER_PERMISO_AYUDA_SOCIAL)
    if (userPermisoAyudaSocial) {
      const valor : string[] = JSON.parse(userPermisoAyudaSocial.valor)
      set({ userPermisoAyudaSocial: valor})
    }

    ///* equipos adicionales
    /* const equiposAdicionales = data.data.find(e => e.slug == 'EQUIPOS_ADICIONALES_PREVENTA');
    if (equiposAdicionales) {
      const valor = JSON.parse(equiposAdicionales.valor);
      console.log(valor);

      set({ equiposAdicionales: valor });
    } */

    set({ isLoadingSystemParams: false });
  },

  emitParametroSistema(params) {
    const socket = useDiccionarioMotivo.getState().socket
    if (!socket) return;
    socket.emit('parametroSistema', params)
  },

  onInformacionSistema() {

    const socket = useDiccionarioMotivo.getState().socket
    if (!socket) return;
    socket.on('informacionSistema', (data: any) => {
      //console.log(data.data.valor);
      set({ mantenimiento: data.data.valor })

    })
  },

}));
